import { createSlice } from '@reduxjs/toolkit';
import createFetchReducer from '@app/utils/createFetchReducer';
import { GenericEntityState, ResponseAction } from '@app/redux/types';
import { getPrebuiltCampaignsTypes, PrebuiltCampaignType } from './types';

export const initialState: GenericEntityState = {
	loading: false,
	error: {},
	response: {
		status: null,
		message: null,
	},
	prebuiltCampaigns: [] as PrebuiltCampaignType[],
	custom: {
		getPrebuiltCampaignsLoading: false,
	},
};

export type PrebuiltCampaignStateType = typeof initialState;

function getPrebuiltCampaignsMapper(
	state: PrebuiltCampaignStateType,
	action: ResponseAction,
) {
	const responseCampaigns = action.response?.prebuiltCampaigns;
	const prebuiltCampaigns: PrebuiltCampaignType[] = Array.isArray(
		responseCampaigns,
	)
		? responseCampaigns
		: Array.isArray(action.response)
			? action.response
			: [];

	state.prebuiltCampaigns = [...prebuiltCampaigns].sort((a, b) => {
		const orderA = a.order ?? Number.MAX_SAFE_INTEGER;
		const orderB = b.order ?? Number.MAX_SAFE_INTEGER;
		return orderA - orderB;
	});
}

const prebuiltCampaignSlice = createSlice({
	name: 'prebuiltCampaign',
	initialState,
	reducers: {
		RESET_PREBUILT_CAMPAIGNS(state: PrebuiltCampaignStateType) {
			state.prebuiltCampaigns = [];
			state.custom = {
				getPrebuiltCampaignsLoading: false,
			};
		},
	},
	extraReducers: {
		...createFetchReducer(
			getPrebuiltCampaignsTypes,
			getPrebuiltCampaignsMapper,
		),
	},
});

export const { RESET_PREBUILT_CAMPAIGNS } = prebuiltCampaignSlice.actions;
export default prebuiltCampaignSlice.reducer;
